<template>
  <div class="requestshipment">
    <div class="row m-0 requestshipment__select">
      <router-link :to="{ name: 'RequestShipment'}"
                   tag="div" class="selectedrequest">
        <img src = "@/assets/image/icon/request-shipment.svg">
        <h1>RFQ</h1>
        <p class="">
          Select Request for Quotation (RFQ) if you looking for a one time shipping solution
        </p>
      </router-link>
      <router-link :to="{ name: 'RequestShipmentContract'}"
                   tag="div" class="selectedrequest">
        <img src = "@/assets/image/icon/contract-shipment.svg">
        <h1>Contract</h1>
        <p class="">
          Select Contract if you looking for a merchant (Freight Forwarder) to handle your multiple shipping for a certain period
        </p>
      </router-link>
      <router-link :to="{ name: 'Warehouse', params: { type: 'create'}}"
                   tag="div" class="selectedrequest">
        <img class="mb-3" src = "@/assets/image/icon/house.svg">
        <h1>Warehouse</h1>
        <p class="">
          Store your items with us at our warehouse for safekeeping
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/view/requestShipmentType/index.vue